<div class="notification-bell relative inline-flex">
  @if (vm$ | async; as vm) {
    <button
      type="button"
      class="relative flex items-center gap-1 rounded-lg p-2 text-gray-600 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-primary/30"
      (click)="toggle($event)"
      [attr.aria-expanded]="dropdownOpen"
      aria-label="Notifications"
    >
      <i class="fas fa-bell text-lg"></i>
      @if (vm.unread > 0) {
        <span
          class="inline-flex min-w-[1.25rem] items-center justify-center rounded-full px-1.5 py-0.5 text-[10px] font-semibold leading-none text-white"
          style="background-color: var(--primary-blue, #2563eb)"
        >
          {{ vm.unread > 9 ? '9+' : vm.unread }}
        </span>
      }
    </button>

    @if (dropdownOpen) {
      <div
        class="absolute right-0 z-[100] mt-1 w-[min(100vw-2rem,22rem)] rounded-xl border border-gray-200 bg-white shadow-lg"
        (click)="$event.stopPropagation()"
      >
        <div class="flex items-center justify-between border-b border-gray-100 px-3 py-2">
          <span class="text-sm font-semibold text-gray-900">Notifications</span>
          @if (vm.unread > 0) {
            <button
              type="button"
              class="text-xs font-medium text-primary hover:underline"
              style="color: var(--primary-blue, #2563eb)"
              (click)="markAllRead($event)"
            >
              Mark all read
            </button>
          }
        </div>
        <ul class="max-h-80 overflow-y-auto py-1">
          @if (vm.notifications.length === 0) {
            <li class="px-4 py-8 text-center text-sm text-gray-500">No notifications yet</li>
          } @else {
            @for (n of vm.notifications; track n.id) {
              <li>
                <button
                  type="button"
                  class="flex w-full flex-col gap-0.5 px-3 py-2.5 text-left transition-colors hover:bg-gray-50"
                  [class.bg-slate-50]="!n.read"
                  (click)="onSelect(n, $event)"
                >
                  <span class="text-sm font-medium text-gray-900">{{ n.title }}</span>
                  @if (n.body) {
                    <span class="line-clamp-2 text-xs text-gray-600">{{ n.body }}</span>
                  }
                  <span class="text-[10px] text-gray-400">{{ n.createdAt | date: 'short' }}</span>
                </button>
              </li>
            }
          }
        </ul>
      </div>
    }
  }
</div>
